import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Seo from "components/shared/Seo";

export const Support = () => {
    return (
        <>
            <Seo title="Help & Support" />
            <h1 className="text-center my-3">Contact Our Support Team</h1>
            {/* Contact Section */}
            <section>
                <Card
                    border="dark"
                    style={{ width: "18rem" }}
                    className="mx-auto"
                >
                    <Card.Body className="text-center">
                        <Card.Title>
                            <FontAwesomeIcon icon={faEnvelope} /> Email Support
                        </Card.Title>
                        <Card.Text>
                            <p className="text-muted mb-4">
                                Send us an email and we'll get back to you
                                within 24 hours.
                            </p>
                            <a
                                href="mailto:support@wishliz.com"
                                className="text-primary fw-medium"
                            >
                                support@wishliz.com
                            </a>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </section>
            {/* FAQ Section */}
            <section className="my-5">
                <h2 className="text-center mb-4">Frequently Asked Questions</h2>
                <div className="mx-auto">
                    <div className="mb-4">
                        <h4 className="fw-bold mb-2">
                            How do I reset my password?
                        </h4>
                        <p className="text-muted">
                            To reset your password, go to the login page and
                            click on "Forgot Password". Enter your email address
                            and we'll send you a link to create a new password.
                            Make sure to check your spam folder if you don't see
                            the email in your inbox.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h4 className="fw-bold mb-2">
                            What payment methods do you accept?
                        </h4>
                        <p className="text-muted mb-3">
                            We accept all major credit cards including Visa,
                            MasterCard, American Express, and Discover. We also
                            support PayPal for your convenience.
                        </p>
                        <ul className="text-muted">
                            <li>Credit/Debit Cards</li>
                            <li>PayPal</li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <h4 className="fw-bold mb-2">
                            How can I cancel my subscription?
                        </h4>
                        <p className="text-muted mb-3">
                            You can cancel your subscription at any time by
                            going to your account profile. From there, click
                            "Cancel Subscription" and follow the prompts.
                        </p>
                        <p className="text-muted mb-2">
                            <strong>Cancellation Process:</strong>
                        </p>
                        <ul className="text-muted">
                            <li>
                                Your subscription will be suspended for 14 days
                                after cancellation
                            </li>
                            <li>
                                During this 14-day period, you can reactivate
                                your subscription at any time
                            </li>
                            <li>
                                After 14 days, your subscription will be
                                permanently cancelled
                            </li>
                            <li>
                                You'll retain access to your account and data
                                during the suspension period
                            </li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <h4 className="fw-bold mb-2">
                            Is there a mobile app available?
                        </h4>
                        <p className="text-muted mb-3">
                            Yes! We have mobile apps available for both iOS and
                            Android devices. You can download them from the App
                            Store or Google Play Store.
                        </p>
                        <div className="d-flex gap-3">
                            <button
                                className="btn btn-dark d-flex align-items-center"
                                disabled
                            >
                                <i className="fab fa-apple me-2"></i>
                                <span>App Store (Coming Soon)</span>
                            </button>
                            <button
                                className="btn btn-success d-flex align-items-center"
                                disabled
                            >
                                <i className="fab fa-google-play me-2"></i>
                                <span>Google Play (Coming Soon)</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
